import React from "react";
import { useFragment } from "react-relay";

import { graphql } from "relay-runtime";

import type { NodesFromEdges } from "~/lib/utils";
import { useCompanyFilterFlagOn } from "~/recordings/Filters/Filters";
import JumpToEventResult from "~/search/JumpTo/JumpToResult/JumpToEventResult";
import JumpToExternalCompanyResult from "~/search/JumpTo/JumpToResult/JumpToExternalCompanyResult";
import JumpToNoteResult from "~/search/JumpTo/JumpToResult/JumpToNoteResult";
import JumpToStreamResult from "~/search/JumpTo/JumpToResult/JumpToStreamResult";
import JumpToTagResult from "~/search/JumpTo/JumpToResult/JumpToTagResult";

import type { JumpToQuery$data } from "~/__generated__/JumpToQuery.graphql";
import type { JumpToResultSearch_result$key as JumpToResultFragmentType } from "~/__generated__/JumpToResultSearch_result.graphql";

const jumpToResultFragment = graphql`
	fragment JumpToResultSearch_result on JumpToResult {
		__typename
		... on NoteStream {
			id
			displayName
			streamUrl: url
		}
		... on Event {
			id
			guid
			title
			url
			isOneOnOne
			start
			nextOccurrence {
				url
			}
			previousOccurrence {
				url
			}
		}
		... on Tag {
			id
			label
		}
		... on Note {
			id
			title
			noteUrl: url
			eventStart
		}
		... on ExternalCompany {
			name
			__typename
		}
	}
`;
export type JumpToQueryResult = NodesFromEdges<JumpToQuery$data["jumpToSearch"]>;
interface JumpToResultProps {
	result: JumpToResultFragmentType;
	index?: number;
}

export default function JumpToResult({ result, ...otherProps }: JumpToResultProps) {
	const isCompanyFilterEnabled = useCompanyFilterFlagOn();

	const data = useFragment(jumpToResultFragment, result);
	if (data.__typename === "NoteStream") return <JumpToStreamResult stream={data} {...otherProps} />;
	if (data.__typename === "Event") return <JumpToEventResult event={data} {...otherProps} />;
	if (data.__typename === "Tag") return <JumpToTagResult tag={data} {...otherProps} />;
	if (data.__typename === "Note") return <JumpToNoteResult note={data} {...otherProps} />;
	if (isCompanyFilterEnabled && data.__typename === "ExternalCompany")
		return <JumpToExternalCompanyResult company={data} {...otherProps} />;
	return null;
}
